// eslint-disable-next-line global-require,import/no-webpack-loader-syntax,import/no-unresolved
export const loadFlatpickr = require('bundle-loader?lazy&name=flatpickr!./flatpickr');
// eslint-disable-next-line global-require,import/no-webpack-loader-syntax,import/no-unresolved
export const loadFlickity = require('bundle-loader?lazy&name=Flickity!./flickity');
